import { Scene, ScenePropertyMappings } from '../common/Scene.js';

import './bootstrap.js';
import 'jquery-ui/dist/jquery-ui';
import 'jquery-ui/dist/themes/base/jquery-ui.min.css';
// import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/dialog';


var scene = new Scene();
var userdata = null;
var sceneBrowser = null;
var userSceneBrowser = null;

var loginLink, logoutLink, userSceneLink, userScenesTable, saveToServerButton;

var speedSlider;

function setDelayForAll() {
	if (scene) {
		let newDelay = Number(document.getElementById("default_delay").value);
		scene.setDelayForAll(newDelay);
	}
}

function saveJSRT() {
    if (scene) {
        scene.saveJSRTToFile();
    }
}

function saveSRT() {
    if (scene) {
        scene.saveSRTToFile();
    }
}

function loadScriptFromText(contents) {
	try {
		var llb = contents.lastIndexOf("}");

		var jsonData = contents.substring(0, llb + 1);
		var srtData = contents.substring(llb + 2);

		var jo = JSON.parse(jsonData);

		createScene(jo);
	}
	catch(e){
		console.log(e);
		alert("Error reading " + f.name + " - " + e.toString());
	}
}

function loadScriptFromJSRT(contents, name) {
	try {
		var llb = contents.lastIndexOf("}");

		var jsonData = contents.substring(0, llb + 1);
		var srtData = contents.substring(llb + 2);

		var jo = JSON.parse(jsonData);
		jo.info.name = name;
		jo.id = "A==";


		createScene(jo);
	}
	catch(e){
		console.log(e);
		alert("Error reading " + f.name + " - " + e.toString());
	}
}

function loadScriptFromFile(f) {
    if (f) {
        console.log("Reading file " + f.name);
        var r = new FileReader();

		if (f.name.includes(".jsrt")) {
        	r.onload = function(e) {
				var contents = e.target.result;
				loadScriptFromJSRT(contents, f.name.replace(".jsrt", ""));
        	}
			r.readAsText(f);
		}
		else if (f.name.includes(".json")) {
			r.onload = function(e) {
				var contents = e.target.result;
				loadScriptFromText(contents);
        	}
			r.readAsText(f);
		}
    }
}

function loadScript(evt) {
    // Get first file from event list
    var f = evt.target.files[0];
    loadScriptFromFile(f);
}

function saveScript() {
    if (scene) {
        scene.saveJSONToFile();
    }
}

function checkLogin() {
	// Check to see if we're logged in...
    fetch('/elysium/account/checklogin', {
        method: "POST"
    })
    .then(response => {
		if (response.status == 429) {
			setTimeout(function() {
				checkLogin()
			}, 1000);
			throw new Error("Too many requests, trying again in one second");
		}
		return response.json()
	}).then(json => {
        console.log(json);
        userdata = json;

        let lit = document.getElementById("loggedintest");

        if (userdata.loggedin) {
            lit.innerHTML = `Welcome, ${userdata.username}`;
			loginLink.style.display = "none";
			logoutLink.style.display = "inline-block";
			userSceneLink.style.display = "inline-block";
			scene.props['author'].value = userdata.username;
			//document.getElementById("author").value = userdata.username;
        }
        else {
            lit.innerHTML = 'You are not logged in. Please <a href="/elysium/account/login" target="_blank">log in</a> here.';
			loginLink.style.display = "inline-block";
			logoutLink.style.display = "none";
			userSceneLink.style.display = "none";
        }
    })
	.catch(err => {
		console.error(err);
	})
}

function getBase64IDFromInt(num) {
	if (num < 0) {
        throw new Error("Cannot encode negative integers to Base64 using this method.");
    }

    let bytes = [];
    // Handle the case of 0 separately to avoid an empty array
    if (num === 0) {
        bytes.push(0);
    } else {
        // Extract bytes in little-endian order (or big-endian, depending on your needs)
        while (num > 0) {
            bytes.push(num & 0xFF); // Get the last byte
            num >>= 8; // Shift right by 8 bits to get the next byte
        }
    }

    // Convert the byte array to a string compatible with btoa()
    // Reverse the bytes if you want big-endian representation in the output
    const byteString = String.fromCharCode(...bytes.reverse()); 

    // Encode the string to Base64
    return btoa(byteString);
}

function refreshUserScenesTable(scenes) {
	userScenesTable.innerHTML = "";

	let headers = false;

	for (let scene of scenes) {
		let sceneRow = document.createElement("tr");
		userScenesTable.appendChild(sceneRow);

		if (!headers) {
			for (let header in scene) {
				if (header != "jsontext") {
					let headerCell = document.createElement("th");
					sceneRow.appendChild(headerCell);
					headerCell.innerHTML = header;
				}
			}
			let controlCell = document.createElement("th");
			sceneRow.appendChild(controlCell);
			controlCell.innerHTML = "Controls";

			sceneRow = document.createElement("tr");
			userScenesTable.appendChild(sceneRow);
			headers = true;
		}

		let jsonID = JSON.parse(scene.jsontext).id;

		for (let column in scene) {
			if (column != "jsontext") {
				let columnCell = document.createElement("td");
				if (column == "id") {
					columnCell.innerHTML = jsonID;
				}
				else if (column == "public") {
					let isPublic = scene.public;
					let publicCheckbox = document.createElement("input");
					publicCheckbox.setAttribute("type", "checkbox");
					publicCheckbox.checked = isPublic > 0;
					columnCell.appendChild(publicCheckbox);

					publicCheckbox.addEventListener("change", function(e) {
						e.preventDefault();
						setScenePublic(jsonID, publicCheckbox.checked ? 1 : 0);
					})
				}
				else {
					columnCell.innerHTML = scene[column];
				}
				
				sceneRow.appendChild(columnCell);
			}
		}

		// Scene controls
		let controlCell = document.createElement("td");
		sceneRow.appendChild(controlCell);

		// Load button
		let loadButton = document.createElement("button");
		controlCell.appendChild(loadButton);
		loadButton.addEventListener("click", function(e) {
			window.top.postMessage(
				{userscene: scene.jsontext}, "*");
		});
		loadButton.innerHTML = "Load";

		// Delete button
		let deleteButton = document.createElement("button");
		controlCell.appendChild(deleteButton);
		deleteButton.addEventListener("click", function(e) {
			deleteUserScene(scene["id"]);
		});
		deleteButton.innerHTML = "Delete";
	}
}

function deleteUserScene(sceneId) {
	if (sceneId == null || sceneId == undefined) return;

	// requires a sceneid
	let endpoint = `/elysium/account/scene/${sceneId}`;

	fetch(endpoint, {
		method: "DELETE",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify({sceneid: sceneId})
	})
	.then(response => {
		return response.json();
	})
	.then(json => {
		if (json.success) {
			fetchUserScenes();
			console.log(json.message);
		}
		else {
			console.error(json.message);
		}
	})
}

function setScenePublic(sceneId, isPublic) {
	let endpoint = `/elysium/account/scene/${sceneId}/privacy/${isPublic}`;

	fetch(endpoint, {
		method: "PUT"
	})
	.then(response => {
		return response.json();
	})
	.then(json => {
		if (json.success) {
			fetchUserScenes();
			console.log(json.message);
		}
		else {
			console.error(json.message);
		}
	})
}

function saveUserScene() {
	// Requires the sceneid from the current scene

	//let sceneId = JSON.parse(scene.jsontext).id;
	let sceneId = scene.json.id;
	//let sceneId = scene.json.id;
	let endpoint = `/elysium/account/scene/${sceneId}`;
	if (scene.lines.length == 0) {
		console.error("Cannot save a scene with no lines... for now...");
		return;
	}
	if (sceneId == null || sceneId == undefined) {
		console.warn("Scene ID is missing! This will be a NEW scene saved on the server");
		endpoint = `/elysium/account/scene/`;
	}

	fetch(endpoint, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify(scene.json)
	})
	.then(response => {
		return response.json();
	})
	.then(json => {
		if (json.success) {
			fetchUserScenes();
			console.log(json.message);
		}
		else {
			console.error(json.message);
		}
	})
}

function fetchUserScenes() {
	fetch("/elysium/account/scenes", {
		method: "GET"
	})
	.then(response => response.json())
	.then(json => {
		refreshUserScenesTable(json);
	});
}

function playScript() {
    if (scene) {
        var player = scene.getPlayer();

        if (player) {
            player.div.dialog("open");
        }
    }
}

function browseScripts() {
	if (sceneBrowser == null) {
		var iframe = $("<iframe></iframe>").attr({
			width: "100%", height: "100%", frameborder: "0",
		}).css({
			"min-width": "100%", "height": "100%",
			"box-sizing": "border-box"
		});
		iframe.attr({src: "../scenebrowser"});
		sceneBrowser = $("<div></div>").attr("id", "browser_div").append(iframe).appendTo("body").dialog({
			autoOpen: false,
			show: {
				effect: "puff",
				duration: 100
			},
			hide: {
				effect: "explode",
				duration: 100
			},
			width: "80vw",
			height: 600,
			title: "Scene Browser",
			close: function() {
				//iframe.attr("src", "");
				//$(this).dialog('destroy').remove();
			}
		});
		sceneBrowser.dialog("open");
	}
	else {
		sceneBrowser.dialog("open");
	}
}

function browseUserScenes() {
	if (userdata == null || userdata.loggedin == false) return;

	if (userSceneBrowser == null) {
		//$("#userScenes").css("display", "block");
		userSceneBrowser = $("#userScenes").dialog();
		fetchUserScenes();
	}
	else {
		userSceneBrowser.dialog("open");
	}
}

function refreshCast() {
	var setCast = function(id) {
		if (!(id in scene.cast)) return;
		var label = (id + 1).toString();
		var namePicker = document.getElementById("cast_" + label + "_name");
		namePicker.value = scene.cast[id].name;

		var colorPicker = document.getElementById("cast_" + label + "_color");
		colorPicker.value = scene.cast[id].color;
	};

	if (scene) {
		for(var c = 0; c < 4; c++) {
			setCast(c);
		}

		var castCount = document.getElementById("cast_count");
		castCount.value = scene.ncharacters;
		castCount.dispatchEvent(new Event('change'));
	}	
}

function refreshSpeed() {
	if (scene && speedSlider) {
		speedSlider.value = scene.speed * 100;
		speedSlider.dispatchEvent(new Event('change'));
	}	
}

function createScene(jsonData = null) {
	clearScene();

	scene = new Scene(jsonData);
	
	refreshCast();
	refreshSpeed();

	/*
	if (Object.keys(scene.json.scene_data).length > 0) {
		// Expand cast, speed, and lines when script is loaded
		var coll = document.getElementsByClassName("collapsible");
		var i;

		for (i = 0; i < coll.length; i++) {
			if (coll[i].collapsed) {
				coll[i].click();
			}
		}

		//$("#lines_button").click();
		
	}
	*/
}

function clearScene() {
    if (scene) {
		scene.clear();
        scene = null;
    }
}

function emptyScript(showAlert) {
    showAlert = showAlert || false;
    if (!showAlert || (showAlert && confirm("Are you sure you want to clear the screen?"))) {
        createScene();
    }
}

window.onmessage = function(e) {
    // This would come from scenebrowser data (PTK scenes with JSRT formatting)
	if ("jsrt" in e.data) {
        let jsrt = e.data.jsrt;
        var llb = jsrt.lastIndexOf("}");
		var jsonData = jsrt.substring(0, llb + 1);

        let json = JSON.parse(jsonData);

        // Fix old PTK json so it'll pass Scriptmaker v4 schema validation
        // For historical reasons, description is what we showed as the title,
        // and long_description was the actual description. The scenebrowser 
        // api fixes this partly, but we still have to set the name. This value
        // comes from the scenebrowser API's getScenes endpoint
        json.info.name = e.data.description;
        json.info.ncharacters = e.data.ncharacters;

        // Gotta give an id as well to pass validation. 6-byte integer, base64-urlencoded
        // compatible. This shouldn't be a meaningful value. If the user is logged in and
        // wants to save the file online, we'll generate that server-side. 
        json.id = "A=="; // 0 as a base64 url-safe string...
        json.scene_data.duration = 0;
        

        // Fix colors for cast
        for(let c of json.scene_data.cast) {
            if (c.color[0] != "#") {
                c.color = "#" + c.color;
            }
        }

        createScene(json);

		if (sceneBrowser) {
			sceneBrowser.dialog("close");
		}
	}

    // This would come from a user's custom scene. 
    if ("userscene" in e.data) {
		let json = JSON.parse(e.data.userscene);
		createScene(json);

		if (userSceneBrowser) {
			userSceneBrowser.dialog("close");
		}
    }
}


window.onload = function() {
    // Make collapsibles
	var coll = document.getElementsByClassName("collapsible");
	var i;

	for (i = 0; i < coll.length; i++) {
		var colli = coll[i];
		coll[i].addEventListener("click", function() {
			this.classList.toggle("active");
			var content = this.nextElementSibling;
			if (content.style.display === "block") {
				content.style.display = "none";
				colli.collapsed = true;
			} else {
				content.style.display = "block";
				colli.collapsed = false;
			}
		});
		colli.collapsed = true;
	}

    // Makes an empty script on startup
	emptyScript();

	// Check login
	checkLogin();

	// Script menu controls (new, open, download, etc)
	document.getElementById("clear_script").addEventListener('click', function(e) {
		e.preventDefault();
		emptyScript(true);
	});

	let scriptFile = document.getElementById("script_file");

	document.getElementById("open_script").addEventListener('click', function(e) {
		e.preventDefault();
		scriptFile.click();
	});

		// Load script and reset value 
	scriptFile.addEventListener('change', function(evt) {
		loadScript(evt);
		scriptFile.value = null;
	}, false);

	// Sets up save JSON link
    document.getElementById("save_script").addEventListener("click", function(e) {
		e.preventDefault();
		saveScript();
	});

	// Sets up save SRT link
    document.getElementById("save_srt").addEventListener("click", function(e) {
		e.preventDefault();
		saveSRT();
	});

	// Sets up save JSRT link
	document.getElementById("save_jsrt").addEventListener("click", function(e) {
		e.preventDefault();
		saveJSRT();
	});

    // Sets up browse link
    document.getElementById("browse_script").addEventListener("click", function(e) {

		e.preventDefault();
		browseScripts();
	});

		// Sets up testing link	
	document.getElementById("test_script").addEventListener('click', function(e) {
		e.preventDefault();
		playScript();
	});

    // Event handler to show/hide cast boxes based on number of players
	var castCount = document.getElementById("cast_count");
	castCount.addEventListener("change", function() {
		var numPlayers = Number(castCount.value);
		if (scene != null && scene.ncharacters != numPlayers) {
			scene.ncharacters = numPlayers;
			scene.createInputs();
		}
		for(var c = 1; c < 5; c++) {
			var row = document.getElementById("cast_" + c.toString());
			if (c <= numPlayers) {
				row.style.display = "block";
			}
			else {
				row.style.display = "none";
			}
		}
	});

	var registerColorEvents = function(id) {
		if (!(id in scene.cast)) return;

		var label = (id + 1).toString();
		var namePicker = document.getElementById("cast_" + label + "_name");
		namePicker.addEventListener('change', function() {
			scene.cast[id].name = this.value;
			scene.createInputs();
		});

		var colorPicker = document.getElementById("cast_" + label + "_color");
		colorPicker.addEventListener('change', function() {
			scene.cast[id].color = this.value;
			scene.createInputs();
		});
	};

	// Cast name and color events
	for (var c = 0; c < 4; c++) {
		registerColorEvents(c);	
	}

	castCount.dispatchEvent(new Event('change'));

	// // Speed slider
	// speedSlider = document.getElementById("speed_slider");

	// // Speed buttons
	// var ssb = document.getElementById("speed_slow_button");
	// ssb.addEventListener("click", function() {
	// 	speedSlider.value = 0;
	// 	speedSlider.dispatchEvent(new Event('change'));
	// });
	// var smb = document.getElementById("speed_medium_button");
	// smb.addEventListener("click", function() {
	// 	speedSlider.value = 50;	
	// 	speedSlider.dispatchEvent(new Event('change'));
	// });
	// var sfb = document.getElementById("speed_fast_button");
	// sfb.addEventListener("click", function() {
	// 	speedSlider.value = 100;	
	// 	speedSlider.dispatchEvent(new Event('change'));
	// });

	// speedSlider.addEventListener('change', function() {
	// 	if (scene != null) {
	// 		var newSpeed = speedSlider.value / 100.0;
	// 		if (scene.speed != newSpeed) {
	// 			scene.speed = newSpeed;
	// 			// maybe don't recompute all line timings when the slider changes?
	// 			// Think of it more like a volume knob to control the current speed...
	// 			// scene.recomputeTimings();	
	// 		}
	// 	}
	// });

	// Do refreshes on login/logout clicks
	loginLink = document.getElementById("accountLoginLink");
	logoutLink = document.getElementById("accountLogoutLink");

	let checkLoginOnRefocus = function(e) {
		checkLogin();
		window.removeEventListener("focus", checkLoginOnRefocus);
	};

	loginLink.addEventListener("click", function(e) {
		window.addEventListener("focus", checkLoginOnRefocus);
	});

	logoutLink.addEventListener("click", function(e) {
		window.addEventListener("focus", checkLoginOnRefocus);
	});

	userSceneLink = document.getElementById("accountScenesLink");
	userSceneLink.addEventListener("click", function(e) {
		browseUserScenes();
	});

	userScenesTable = document.getElementById("userScenesTable");

	saveToServerButton = document.getElementById("saveToServer");
	saveToServerButton.addEventListener("click", function(e) {
		saveUserScene();
	})


	let setDelayButton = document.getElementById("set_delay_all_button");
	setDelayButton.addEventListener("click", function(e) {
		setDelayForAll();
	})

};